/* @refresh reload */
import { installConsoleCapture } from './components/DevConsole/consoleCapture';
import { Router } from '@solidjs/router';
import { render } from 'solid-js/web';
import App from './App';
import { AssetsProvider, Theme, ThemeProvider, UpdateAppToast, defaultTheme } from './components';
import { SETTINGS } from './settings';
import './styles/global.scss';
import { configureAmplify, initAnalytics, initSentry, isLiveEnvironment, storage } from './utils';
import { cleanCache } from './utils/cache';

// Capture console output (dev mode only) as early as possible
installConsoleCapture();

// Set up sentry
initSentry();

// Set up amplify
// NOTE: currently not using the amplify SDK to query the api
configureAmplify();

// Make sure we have deleted any old cached api responses
cleanCache(SETTINGS.API_CACHE_NAME, SETTINGS.API_CACHE_EXPIRES_AFTER_HOURS);

// Make sure we have removed any old cached images
cleanCache(SETTINGS.IMAGE_CACHE_NAME, SETTINGS.IMAGE_CACHE_EXPIRES_AFTER_HOURS);

// Set up analytics
initAnalytics();

// Set up our theme
const theme: Theme = {
  ...defaultTheme,
  mode: storage.getItem('theme') === 'light' ? 'light' : 'dark',
};

render(
  () => (
    <ThemeProvider theme={theme}>
      <AssetsProvider stripeKey={isLiveEnvironment() ? SETTINGS.STRIPE_KEY_LIVE : SETTINGS.STRIPE_KEY_TEST}>
        <UpdateAppToast />
        <Router>
          <App />
        </Router>
      </AssetsProvider>
    </ThemeProvider>
  ),
  document.getElementById('root') as HTMLElement,
);

// Dev-only console overlay (dynamic import is stripped from production builds)
if (import.meta.env.DEV) {
  import('./components/DevConsole/DevConsole').then(({ default: DevConsole }) => {
    const el = document.createElement('div');
    el.id = 'dev-console-root';
    document.body.appendChild(el);
    render(() => <DevConsole />, el);
  });
}
